var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import FilterRule from './FilterRule';
/**
 *
 */
var FilterObjectRule = /** @class */ (function (_super) {
    __extends(FilterObjectRule, _super);
    /**
     *
     * @param param
     * @param operator
     */
    function FilterObjectRule(param, operator) {
        var _this = this;
        if (!Array.isArray(param)) {
            throw new Error('invalid paramter type, Array expected');
        }
        _this = _super.call(this, param) || this;
        _this.operator = operator;
        return _this;
    }
    /**
     *
     * @param object
     * @return {boolean}
     */
    FilterObjectRule.prototype.apply = function (object) {
        if (!object) {
            return false;
        }
        if (this.value === null || !this.parameter) {
            return true;
        }
        var objectValue;
        var currentObject = object;
        this.parameter.forEach(function (key) {
            if (!currentObject)
                return false;
            currentObject = currentObject[key];
        });
        objectValue = currentObject;
        switch (this.operator) {
            case '<':
                return objectValue < this.value;
            case '>':
                return objectValue > this.value;
            case '<=':
                return objectValue <= this.value;
            case '>=':
                return objectValue >= this.value;
            case '!=':
            case '!==':
                return objectValue !== this.value;
            default:
                return objectValue === this.value;
        }
    };
    return FilterObjectRule;
}(FilterRule));
export default FilterObjectRule;
